import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const LANG_KEY = 'app_lang';
const DEFAULT_LANG = 'ar';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private langSubject = new BehaviorSubject<string>(this.getStoredLang());
  currentLang$ = this.langSubject.asObservable();

  constructor() {
    this.applyLang(this.getStoredLang());
  }

  get currentLang(): string {
    return this.langSubject.value;
  }

  private getStoredLang(): string {
    return localStorage.getItem(LANG_KEY) || DEFAULT_LANG;
  }

  setLang(lang: 'ar' | 'en'): void {
    localStorage.setItem(LANG_KEY, lang);
    this.langSubject.next(lang);
    this.applyLang(lang);
  }

  toggleLang(): void {
    const next = this.currentLang === 'ar' ? 'en' : 'ar';
    this.setLang(next);
  }

  private applyLang(lang: string): void {
    document.documentElement.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
    document.documentElement.setAttribute('lang', lang);
  }
}
